const assessmentInterpretations = {
  // "Stress Level for Overeating": {
  //   out_of_score: 18,
  //   results: [
  //     { range: [0, 3], interpretation: "This indicates low impact overeating likely due to minor stress. This score generally needs basic self awareness and stress management strategies and we recommend  simple mindfulness practices and monitoring your eating patterns along with these orientation counselling." },
  //     { range: [4, 7], interpretation: "This indicates overeating due to moderate stress, which may be becoming a more noticeable pattern due to moderate stress. This score generally needs stress management techniques to help manage triggers and prevent further escalation and we recommend practicing relaxation and stress-reduction techniques along with these orientation counselling." },
  //     { range: [8, Infinity], interpretation: "This indicates significant stress or emotional eating patterns that may be affecting both your emotional and physical health due to severe stress. This score generally needs professional intervention to address the underlying emotional triggers and help manage the overeating behavior and we recommend seeking therapy or counseling to explore the emotional factors contributing to this pattern, with stress management techniques along with these orientation counselling." },
  //   ],
  //   progressBarSettings: {
  //     thresholds: [4, 8],
  //     labels: ["Low", "Moderate", "High"],
  //     colors: ["#4caf50", "#ff9800", "#f44336"],
  //   },
  // },
  "Stress Level for Overeating": {
    out_of_score: 18,
    scoreMessage: "Your score in stress assessment is {score}.",
    interpretationHeading: "Interpretation",
    interpretationSummary: [
      "0-3: Low impact overeating. Likely due to minor stress.",
      "4-7: Moderate impact overeating. Stress management recommended.",
      "8+: High impact overeating. Indicates significant stress or emotional eating patterns."
    ],
    results: [
      { range: [0, 3], text: "This indicates low impact overeating likely due to minor stress. This score generally needs basic self awareness and stress management strategies and we recommend  simple mindfulness practices and monitoring your eating patterns along with these orientation counselling." },
      { range: [4, 7], text: "This indicates overeating due to moderate stress, which may be becoming a more noticeable pattern due to moderate stress. This score generally needs stress management techniques to help manage triggers and prevent further escalation and we recommend practicing relaxation and stress-reduction techniques along with these orientation counselling." },
      { range: [8, Infinity], text: "This indicates significant stress or emotional eating patterns that may be affecting both your emotional and physical health due to severe stress. This score generally needs professional intervention to address the underlying emotional triggers and help manage the overeating behavior and we recommend seeking therapy or counseling to explore the emotional factors contributing to this pattern, with stress management techniques along with these orientation counselling." }
    ],
    progressBarSettings: {
      thresholds: [4, 8],
      labels: ["Low", "Moderate", "High"],
      colors: ["#4caf50", "#ff9800", "#f44336"]
    }
  },
  "Physical Activity": {
    out_of_score: 13,
    interpretationHeading: "Interpretation",
    scoreMessage: "Your Physical Activity score is {score}.",
    interpretationSummary: [
      "(0-4): You are inclined for sedentary lifestyle",
      "4+: You are physically active",
    ],
    results: [
      { range: [5, Infinity], text: "Your score indicates that you are physically active. Being physically active helps to maintain basal metabolic rate (BMR), energy consumption to expenditure balance, bone, muscles, joint health and heart and lung functioning. It also helps maintaining body hormones to keep sugar and lipids in normal range avoiding excessive weight gain, obesity, metabolic disorders like diabetes, high lipids, high blood pressure and falls fractures.  You are advised to consult a physical coach for qualitative and quantitative assessments and get an appropriate exercise schedule." },
      { range: [0, 4], text: "Your score indicates inclination towards sedentary life style. Sedentary lifestyle is associated with overweight, obesity, metabolic disorders like diabetes, high blood lipids and high blood pressure. You are advised to take immediate action and consult an expert for qualitative and quantitative assessments and get an appropriate exercise schedule. "},
    ],
    progressBarSettings: {
      thresholds: [5],
      labels: ["Physically active", "Need to be more mctive"],
      colors: ["#4caf50", "#ff9800"],
    },
  },
  "Binge Eating": {
  out_of_score: 76,
  scoreMessage: "Your score in stress assessment is {score}.",
  interpretationHeading: "Interpretation",
  interpretationSummary: [
    "Normal (0-18):\n Indicates no significant symptoms of binge eating.\n Suggests a healthy relationship with food and eating habits.",
    "Mild (19-37): Suggests occasional binge eating episodes.\n May indicate a developing issue, with eating being used to cope with stress or emotions.",
    "Moderate (38-56): Points to frequent binge eating episodes. \n Likely associated with distress and challenges in managing eating behavior. May benefit from professional intervention, such as therapy or counseling.",
    "Severe (57+): Reflects a serious pattern of binge eating.\n Often linked to significant emotional distress and potential health risks. Strongly recommended to seek professional help, such as a psychologist, psychiatrist, or specialized treatment program."
  ],
    
  results: [
    { range: [0, 18], text: "Your score indicates no significant symptoms of binge eating. This score generally needs no immediate intervention and reflects a healthy relationship with food. We recommend maintaining a balanced lifestyle and monitoring your habits along with these orientation counselling." },
    { range: [19, 37], text: "Your score indicates occasional binge eating episodes, which may indicate a developing issue where eating is used to cope with stress or emotions. This score generally needs increased self-awareness and early strategies to address triggers before the issue worsens. We recommend building healthier coping mechanisms, and considering brief counselling sessions along with these orientation counselling." },
    { range: [38, 56], text: "Your score indicates frequent binge eating episodes that are likely associated with distress and challenges in managing eating behavior. This score generally needs professional intervention to address these patterns and their underlying causes. We recommend seeking therapy or counseling to develop healthier coping strategies and manage emotional triggers along with these orientation counselling." },
    { range: [57, Infinity], text: "Your score indicates a serious pattern of binge eating often linked to significant emotional distress and potential health risks. This score generally needs immediate professional intervention to address the issue effectively. We recommend seeking help from a psychologist, psychiatrist, or a specialized treatment program to manage these behaviors and address emotional and physical health concerns along with these orientation counselling." }
  ],
  progressBarSettings: {
    thresholds: [19, 38, 57],
    labels: ["Normal", "Mild", "Moderate", "Severe"],
    colors: ["#2e7d32", "#4caf50", "#ff9800", "#f44336"]
  }
},
  "Abdominal Obesity": {
    interpretationHeading: "Interpretation",
    scoreMessage: "Your Physical Activity score is {score}.",
    results: [
      { range: [0,0], interpretation: "No significant abdominal obesity." },
      { range: [1, 3], interpretation: "Your score indicates abdominal obesity and insulin resistance. It is an independent risk factor for heart diseases, diabetes and polycystic ovarian syndrome, fatty liver etc. Carbohydrate restricted diet is a scientific strategy help reversing abdominal obesity, pre-diabetes and insulin resistance. It's time to Reduce carbohydrates mindfully ....!!!" },
    ],
    progressBarSettings: {
      thresholds: [1],
      labels: ["Normal", "Obesity"],
      colors: ["#2e7d32", "#f44336"]
    }
  },
  "Insulin Resistance and Pre-diabetes": {
    interpretationHeading: "Interpretation",
    scoreMessage: "Your Physical Activity score is {score}.",
    results: [
      { range: [0,0], interpretation: "No significant effect." },
      { range: [1, 3], interpretation: "You may be at higher risk of pre-diabetes/diabetes. Carbohydrate restricted diet is a scientific strategy help reversing abdominal obesity, pre-diabetes and insulin resistance. It's time to Reduce carbohydrates mindfully ....!!!" },
    ],
    progressBarSettings: {
      thresholds: [1],
      labels: ["Normal", "Pre-diabetes"],
      colors: ["#2e7d32", "#f44336"]
    }
  },
  "Insulin Resistance": {
    results: [
      { range: [0,0], interpretation: "No significant effect." },
      { range: [1, 3], interpretation: "It indicates Insulin resistance. Insulin resistance is underlying cause of many disorders like weight gain, obesity, pre-diabetes, diabetes, high blood pressure, heart diseases, polycystic ovarian syndrome (PCOS), Non alcoholic fatty liver disease (NAFLD) etc..Carbohydrate restricted diet is a scientific strategy help reversing abdominal obesity, pre-diabetes and insulin resistance. It's time to Reduce carbohydrates mindfully ....!!!" },
    ],
    progressBarSettings: {
      thresholds: [1],
      labels: ["Normal", "High"],
      colors: ["#2e7d32", "#f44336"]
    }
  },
    "Diet and Lifestyle habits": {
      out_of_score: "",
      scoreMessage: "Your diet and lifestyle score is {score}.",
    interpretationHeading: "Interpretation",
    interpretationSummary: [
      "-2 to -1:\n Unhealthy habits",
      "-1 to 0: Need improvement",
      "0: Consider fine tuning",
      "0 to +1: Healthy habits",
      "+1 to +2: Excellent habits"
    ],
      results: [
        {
          range: [-200, -1],
          text: "It is not a good score and needs immediate improvement. You need to be diet and lifestyle conscious, make better food choices, and reduce the frequency of outside food or packaged food."
        },
        {
          range: [-1, 0],
          text: "It needs improvement. You should be diet conscious and choose healthier food options by avoiding processed and packaged foods. Reduce the number of times you eat outside food."
        },
        {
          range: [0, 0],
          text: "Your diet choices and lifestyle habits are health optimal. You may continue and fine-tune them by choosing healthier home-cooked meal options."
        },
        {
          range: [0, 1],
          text: "You have healthy dietary choices and an active lifestyle. Very good!!! You are on a healthy path. Continue eating healthy home-cooked meals and avoid processed or packaged foods."
        },
        {
          range: [1, Infinity],
          text: "You are a role model. Excellent!!! You are on a healthy path. Continue eating healthy home-cooked meals and avoid processed or packaged foods."
        }
      ],
      progressBarSettings: {
        thresholds: [-1, 0, 1, 2],
        labels: ["Unhealthy habits", "Need improvement", "Consider fine tuning", "Healthy habits", "Excellent habits"],
        colors: ["#f44336", "#ff9800", "#ffc107", "#4caf50", "#2e7d32"]
      }

      
    },

    "Daily carbohydrate intake (24 hours Diet Recall)": {
      scoreMessage: "Your daily carbohydrate intake is approximately {score} gm.",
  interpretationHeading: "Interpretation",
  interpretationSummary: [
    "(>240gms) Extremely high carbohydrate intake: Need immediate intervention !!!!",
    "(180-240gms) Considerably high carbohydrate intake: Needs attention!!!",
    "(150-180gms) Slightly High carbohydrate intake: The right time to optimise!!!",
    "(130-150gms) Optimal Intake: Excellent Keep it up !!"
  ],
  out_of_score: '',
  results: [
    { range: [0, 150], text: "It is an optimal intake for vital body functions. You are a role model. You are recommended to continue on this path. Optimal carbohydrate intake provides a steady source of energy, supports healthy brain function, and helps maintain stable blood sugar levels. It also promotes proper digestion when coming from fibre-rich sources like whole grains, fruits, and vegetables." },
    { range: [151, 180], text: "It is slightly high consumption. You are recommended to gradually optimise your carbohydrate intake. Eating slightly more carbohydrates than required can lead to minor weight gain if the excess energy is not burned off through active lifestyle. It may also cause temporary blood sugar spikes and energy fluctuations. Overconsumption of carbohydrates consistently for longer time may cause serious lifestyle disorders like Diabetes, cardiovascular diseases etc. High carbohydrate consumtion may lead to overweight, obesity, pre-diabetes and metabolic disorders. It's time to Reduce carbohydrates mindfully ....!!! " },
    { range: [181, 240], text: "It is a considerably high consumption. You are advised to gradually reduce carbohydrate intake, as high carbohydrate intake, especially from refined sugars, can lead to rapid blood sugar spikes leading to wide glucose fluctuations (also called as glycemic variability), weight gain, persistently high insulin with increased risk of insulin resistance and type 2 diabetes. It may also cause fluctuations in energy levels, mood swings, and contribute to long-term health issues like obesity, high blood pressure, metabolic disorders, heart disease etc. High carbohydrate consumtion may lead to overweight, obesity, pre-diabetes and metabolic disorders. It's time to Reduce carbohydrates mindfully ....!!! " },
    { range: [241, Infinity], text: "It is an extremely high consumption. You are advised to gradually reduce carbohydrate intake immediately as extremely high carbohydrate intake, particularly from refined sugars, can lead to blood glucose fluctuations (also called as glycemic variability), significant weight gain, abdominal obesity, insulin resistance, and an increased risk of type 2 diabetes. It may also cause elevated triglycerides, cardiovascular issues, and mood swings due to fluctuating blood sugar levels. Consult the expert immediately. High carbohydrate consumtion may lead to overweight, obesity, pre-diabetes and metabolic disorders. It's time to Reduce carbohydrates mindfully ....!!! " }
  ],
  progressBarSettings: {
    thresholds: [151, 181, 241],
    labels: ["Optimal", "Slightly High", "Considerably High ", "Extremely High"],
    colors: ["#2e7d32", "#4caf50", "#ff9800", "#f44336"]
  }
},
"Behavioral Change Readiness": {
  out_of_score: '85',
  scoreMessage: "Your score in behavioral change readiness is {score}.",
  interpretationHeading: "Interpretation",
    interpretationSummary: [
      "Minimal readiness (0-25): Patient may need more time to prepare for change. Focus on building motivation and confidence.",
      "Moderate readiness (26-41): Work on specific strategies to increase commitment and confidence.",
      "High readiness (42-85): Patient is likely prepared to take action toward behavioral change."
    ],
  results: [
    { range: [0, 25], text: "This indicates you may need more time to prepare for change. Focus should be on building motivation and confidence before proceeding with more intensive interventions. This score generally needs support in increasing awareness and readiness for change to make sustainable improvementsand we recommend setting small, achievable goals and building self-confidence through positive reinforcement along with these orientation counselling." },
    { range: [26, 41], text: "This indicates moderate readiness to address the issue. It is important to work on specific strategies to increase commitment and confidence in making lasting changes. This score generally needs targeted strategies and motivation-building techniques to strengthen commitment to change and we recommend setting clear, actionable goals and focusing on small steps to increase confidence and commitment along with these orientation counselling." },
    { range: [42, 85], text: "This indicates high readiness to address the issue and you are  likely prepared to take action toward behavioral change and can benefit from more structured interventions. This score generally needs focused strategies to help transition readiness into actionable change and we recommend engaging in targeted interventions such as therapy or behavioral strategies, and setting up a clear action plan along with these orientation counselling." }
  ],
  progressBarSettings: {
    thresholds: [26, 42],
    labels: ["Minimal Readiness", "Moderate Readiness", "High readiness "],
    colors: ["#f44336", "#ff9800", "#4caf50"]
  }
},

  }
  

  
const getScoreInterpretation = (assessmentName, score) => {
  const assessment = assessmentInterpretations[assessmentName];
  

    if (!assessment) {
        return { 
            interpretationHeading: "No Interpretation Available",
            scoreMessageText: `Your score: ${score}`,
            interpretationSummary: [],  // Ensure it's always an array
            selectedInterpretation: "No interpretation found.",
            out_of_score: 0,
            adjustedScore: score
        };
    }

    let adjustedScore = score;
    let { out_of_score, results, scoreMessage, interpretationHeading, interpretationSummary = [] } = assessment;

    let scoreMessageText = scoreMessage.replace("{score}", score);
    let selectedInterpretation = results.find(({ range }) =>
        adjustedScore >= range[0] && adjustedScore <= range[1]
    )?.text || "No specific interpretation available.";

    return {
        interpretationHeading,
        scoreMessageText,
        interpretationSummary,  // This will always be an array
        selectedInterpretation,
        out_of_score,
        adjustedScore
    };
};

export { assessmentInterpretations as default, getScoreInterpretation };

